import { Skeleton } from "@mui/material";

export default function TrendFoodMenuItemSkeleton() {
  return (
    <>
      <Skeleton
        variant="text"
        sx={{ width: "20%", marginTop: 5 }}
        animation="wave"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          borderRadius: "7px",
          width: "40%",
          height: {
            xs: "180px",
            sm: "200px",
            md: "280px",
          },
        }}
      />
      <Skeleton variant="text" sx={{ width: "20%" }} animation="wave" />
      <Skeleton variant="text" sx={{ width: "20%" }} animation="wave" />
    </>
  );
}